<template>
    <div class="scene">
        <video class="video" src="../../assets/sakura.mp4" autoplay loop muted playsinline></video>
        <div id="myContent">
            <span id="blink" style="display: none;"></span>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.charIndex = -1
        this.stringLength = 0
        this.inputText = '陈林子<br>你好吗<br>三周年快乐'
        this.currentStyle = 'inline'
        this.writeContent(true)
    },

    methods: {
        writeContent() {
            if (this.charIndex==-1){
                this.charIndex = 0;
                this.stringLength = this.inputText.length;
            }
	        var initString = document.getElementById('myContent').innerHTML;
	        initString = initString.replace(/<SPAN.*$/gi,"");

            var theChar = this.inputText.charAt(this.charIndex);
            var nextFourChars = this.inputText.substr(this.charIndex,4);
            if(nextFourChars=='<BR>' || nextFourChars=='<br>'){
                theChar  = '<BR>';
                this.charIndex+=3;
            }
            initString = initString + theChar + "<SPAN id='blink'>_</SPAN>";
            document.getElementById('myContent').innerHTML = initString;

            this.charIndex = this.charIndex/1 +1;
            if(this.charIndex%2==1){
                document.getElementById('blink').style.display='none';
            }else{
                document.getElementById('blink').style.display='inline';
            }

            if (this.charIndex<=this.stringLength){
                setTimeout(()=>{
                    this.writeContent(false)
                }, 200)
            }else{
                this.blinkSpan();
            }  
        },

        blinkSpan() {
            if(this.currentStyle=='inline'){
                this.currentStyle='none'
            }else{
                this.currentStyle='inline'
            }
            document.getElementById('blink').style.display = this.currentStyle
            setTimeout(() => {
                this.blinkSpan()
            }, 100);
        }
    }
}
</script>

<style scoped>
.scene {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.video {
    width: 100vw; 
    height: 100vh; 
    object-fit: cover;
}

#myContent {
    position: absolute;
    z-index: 999;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    overflow: hidden;
    text-shadow: 1px 1px 1px #000; 
    font-style: italic;
    font-size: 30px;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/scene1/Scene1.vue